import type { BacklogHttpResponse } from "../contracts/api/BacklogHttpResponse";
import { BacklogError } from "./BacklogError";

export class BacklogApiBaseError extends BacklogError {
	public readonly response: BacklogHttpResponse;
	constructor(
		protected readonly options: {
			readonly response: BacklogHttpResponse;
			readonly message: string;
		},
	) {
		super(options.message);
		this.response = options.response;
	}
}
